var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.locations),function(location,idx){return _c('span',{key:location.id},[_c('router-link',{attrs:{"to":{ name: 'View Location', params: { id: location.id } }}},[_vm._v(" "+_vm._s(`${location.name}`)+" ")]),_vm._v(" "+_vm._s(_vm.locations.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }